import { useState } from "react";
import { useNavigate } from "react-router";
import DispensationsTable from "../../../components/DispensationsTable";
import RoundedCard from "../../../components/RoundedCard";
import { useDispensations } from "@/hooks/useDispensations";

type DispensationsDocumentTabProps = {
  detailPathPrefix?: string;
  description: string | null;
  reported?: boolean | null;
  showStatusColumn?: boolean;
  title: string;
};

const DISPENSATIONS_PAGE_SIZE = 10;

const DispensationsDocumentTab = ({
  detailPathPrefix = "",
  description,
  reported,
  showStatusColumn = true,
  title,
}: DispensationsDocumentTabProps) => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const {
    data: response,
    isError,
    isFetching,
    isLoading,
  } = useDispensations({
    page,
    page_size: DISPENSATIONS_PAGE_SIZE,
    reported,
  });

  const handleDispensationClick = (documentId: string) => {
    void navigate(`${detailPathPrefix}dispensation/${documentId}`);
  };

  return (
    <RoundedCard
      bodyClassName="p-0 mt-3"
      header={title}
      description={description}
    >
      <DispensationsTable
        isError={isError}
        isLoading={isLoading}
        onDispensationClick={handleDispensationClick}
        dispensations={response?.items ?? []}
        showStatusColumn={showStatusColumn}
        pagination={
          response
            ? {
                isDisabled: isFetching,
                onPageChange: setPage,
                page: response.page,
                total: response.total,
                totalPages: response.totalPages,
              }
            : undefined
        }
      />
    </RoundedCard>
  );
};

export default DispensationsDocumentTab;
